import { extractApiErrorMessage, extractValidationErrors } from '../../../Utils/apiErrorUtils';

const normalizeApiFieldPath = (fieldPath: string): string => {
  return fieldPath
    .replace(/^\$?\./, '')
    .replace(/\[(\d+)\]/g, '.$1')
    .split('.')
    .map((segment) => {
      if (!segment) {
        return segment;
      }

      return segment.charAt(0).toLowerCase() + segment.slice(1);
    })
    .join('.');
};

export const extractEntityFormApiErrors = (
  error: unknown,
  fallbackMessage: string
): {
  submitErrorMessage: string;
  fieldErrors: Record<string, string>;
} => {
  const validationErrors = extractValidationErrors(error);
  const fieldErrors: Record<string, string> = {};

  if (validationErrors) {
    Object.entries(validationErrors).forEach(([fieldName, messages]) => {
      const firstMessage = Array.isArray(messages) ? messages[0] : undefined;
      if (!firstMessage) {
        return;
      }

      fieldErrors[normalizeApiFieldPath(fieldName)] = firstMessage;
    });
  }

  return {
    submitErrorMessage: extractApiErrorMessage(error, fallbackMessage),
    fieldErrors,
  };
};
